import React, { FC, useContext } from "react";
import { observer } from 'mobx-react-lite';
import { LeftPaneContext } from "../../LeftPaneContext";
import { TreeNode, TreeNodeLabel } from '../TreeNode';
import { InstructionNodeProps } from './InstructionNodeFactory';
import { WaitInstruction, Axis, Input } from '../../../../../machinelogic/types';
import { isInputPushButton, PushButtonInputEdgeLabels, PushButtonInputLevelLabels } from "../../../../../constants";

interface WaitInstructionProps extends InstructionNodeProps {
  instruction: WaitInstruction;
}
type GetAxisByUuid = (uuid: string) => Axis | undefined;
type GetInputByUuid = (uuid: string) => Input | undefined;

interface GetInstructionLabelProps {
    instruction: WaitInstruction
    getInputByUuid: GetInputByUuid
    getAxisByUuid: GetAxisByUuid
}

const getInstructionLabelName = ({instruction, getInputByUuid, getAxisByUuid}: GetInstructionLabelProps): string => {
  switch(instruction.name) {
    case 'amountOfTime':
      return `Wait for ${instruction.parameters.milliseconds} ms`;
    case 'digitalInput': {
      const input = getInputByUuid(instruction.parameters.inputUuid);
      const inputName = input?.name || 'UNKNOWN Input';
      const pushButtonLabel = PushButtonInputLevelLabels[instruction.parameters.level];
      const inputValue = isInputPushButton(input) ? pushButtonLabel : instruction.parameters.level;
      return `Wait for ${inputName} = ${inputValue}`;
    }
    case 'digitalInputEdge': {
      const input = getInputByUuid(instruction.parameters.inputUuid);
      const inputName = input?.name || 'UNKNOWN Input';
      const pushButtonLabel = PushButtonInputEdgeLabels[instruction.parameters.edge];
      const inputValue = isInputPushButton(input) ? pushButtonLabel : instruction.parameters.edge;
      return `Wait for ${inputName} ${inputValue} transition`;
    }
    case 'event':
      return `Wait for '${instruction.parameters.topic}' event`;
    case 'motionCompletion': {
      const axis = getAxisByUuid(instruction.parameters.axis);
      const axisName = axis?.name || 'UNKNOWN Axis';
      const allAxis = instruction.parameters.axis === 'all';
      return `Wait for ${allAxis ? 'all' : axisName} Motion Complete`;
    }
  }
};

export const WaitNode: FC<WaitInstructionProps> = observer(({instruction, titleClassName = '', isSelected, isInvalid, onClick}) => {

  const { library } = useContext(LeftPaneContext);
  const getInputByUuid = (uuid) => library.getConfigManager().getInputByUuid(uuid);
  const getAxisByUuid = (uuid) => library.getConfigManager().getAxisByUuid(uuid);

  const instructionLabel = <TreeNodeLabel
    icon="icon-time"
    name={getInstructionLabelName({instruction, getInputByUuid, getAxisByUuid})}
    isSelected={isSelected}
    isInvalid={isInvalid}
    onClick={onClick}
  />;

  return (
    <TreeNode title={instructionLabel} titleClassName={titleClassName} />
  );
});
